import type { CharacterWithUrls } from 'schemas';
import { getGenderLabel } from '@/helpers/getGenderLabel';
import type { EntityCardProps } from '@/components/EntityCard';

/**
 * Transforms character data to EntityCard component props
 * @param character - Character with URLs from the API
 * @returns Props object for EntityCard component
 */
export const transformCharacterToEntityCard = (
  character: CharacterWithUrls
): EntityCardProps => {
  // Prepare image URLs
  const imageUrls: string[] = [];
  if (character.previewImageUrl) {
    imageUrls.push(character.previewImageUrl);
  }
  if (character.referenceImageUrl) {
    imageUrls.push(character.referenceImageUrl);
  }

  // Prepare details
  const details = [
    { label: 'Age', value: character.age },
    { label: 'Gender', value: getGenderLabel(character.gender) },
    { label: 'Type', value: character.character_type },
  ].filter((detail) => detail.value); // Only include details with values

  // Prepare tags from character traits
  const tags = character.character_traits?.slice(0, 3) || [];

  return {
    title: character.name,
    description: character.appearance || null,
    imageUrls: imageUrls.length > 0 ? imageUrls : undefined,
    imageAlt: character.name,
    tags: tags.length > 0 ? tags : undefined,
    details: details.length > 0 ? details : undefined,
  };
};
